import React from 'react';
import AdminLogin from '../components/admin/AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';
import { useSession } from '../lib/auth';

function AdminPage() {
  const { data: session, isPending } = useSession();

  if (isPending) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // 检查用户是否已登录且是管理员
  const isAdmin = session?.user && (session.user as any).role === 'admin';

  if (!session || !isAdmin) {
    return <AdminLogin />;
  }

  return <AdminDashboard />;
}

export default AdminPage;